import {MAILING_TYPE_TEXT, MAILING_TYPE_NEWS} from '@/constants'
import Mailing from '@/models/mailing/mailing'
import _ from 'lodash'
import sort from '@/services/sorting'

import router from '@/routes'
import store from '@/store'

import {ActiveTableConfig} from '@/components/Ui/ActiveTable/BZCore/ActiveTable'
import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'
import {TableOptions} from '@/components/Ui/ActiveForm/BZCore/Table/Table'

import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'
import NumberField from '@/components/Ui/ActiveForm/BZCore/Fields/NumberField'
import SelectField, {SelectFieldOptions} from '@/components/Ui/ActiveForm/BZCore/Fields/SelectField'

import indexComponent from '@/components/Newsletters-stuff/TableCols/indexColumn.vue'
import recipientsComponent from '@/components/Newsletters-stuff/TableCols/recipients.vue'
import statusComponent from '@/components/Newsletters-stuff/TableCols/status.vue'
import typeComponent from '@/components/Newsletters-stuff/TableCols/type.vue'
import textComponent from '@/components/Newsletters-stuff/TableCols/text.vue'
import ratingComponent from '@/components/Newsletters-stuff/TableCols/rating.vue'

// @ts-ignore
import messages from '@/lang/index';

const StudentsActiveTableConfig: ActiveTableConfig<Mailing> = {
  documentsName: messages.newsletters.mailings1,
  indexColumnComponent: indexComponent,
  onRowClick ({row}) {
    router.push({name: 'newsletterPageStuff', params: {id: row.getId()}})
  },
  async find (search, filters, sortKeys, limit, offset, scope) {
    if (filters.type && !filters.type.length) {
      delete filters.type
    }
    const params = {
      limit,
      offset,
      query: {
        staff: true,
        ...filters,
        ...scope
      }
      // sort
    }
    const result = await store.dispatch('mailing/find', params)
    return {
      count: result.count,
      list: result.mailings
    }
  },
  filtersAndActions: {
    pageName: messages.newsletters.filters.title,
    searchFormButtonText: messages.newsletters.filters.search,
    filters: {
      type: {
        type: SelectField,
        label: messages.newsletters.filters.types.title,
        options: {
          values: [
            {label: messages.newsletters.filters.types.manual, value: MAILING_TYPE_TEXT},
            {label: messages.newsletters.filters.types.news, value: MAILING_TYPE_NEWS},
          ],
          multiSelect: true
        },
      } as ActiveFieldOptions<SelectFieldOptions>
    }
  },
  actions: [
    {
      name: messages.common.delete,
      icon: 'trash',
      async handler (item) {
        await store.dispatch('mailing/delete', item.getId())
        return true
      }
    }
  ],
  defaultShownColumns: ['text', 'recipients', 'type', 'rating', 'rcpt_num', 'date', 'status'],
  table: {
    cols: {
      text: {label: messages.newsletters.table.text, component: textComponent, styles: {maxWidth: '240px'}},
      id: {label: messages.newsletters.table.id, styles: {maxWidth: '100px'}},
      recipients: {label: messages.newsletters.table.recipients, component: recipientsComponent},
      type: {label: messages.newsletters.table.type, component: typeComponent},
      rating: {label: messages.newsletters.table.rating, component: ratingComponent, styles: {minWidth: '140px', width: '140px'}},
      rcpt_num: {label: messages.newsletters.table.rcpt_num},
      date: {label: messages.newsletters.table.date},
      status: {label: messages.newsletters.table.status, component: statusComponent},
    }
  } as TableOptions
}
export default StudentsActiveTableConfig
